export enum TabType { VIEW="VIEW", MODEL_CREATOR="MODEL_CREATOR", METRICS="METRICS", SIMULATION="SIMULATION" }